import { gql } from '@apollo/client';

export const UPDATE_USER_DETAILS = gql`
  mutation updateUserDetails(
    $fullName: String
    $doneOnBoarding: Boolean
    $pushNotificationsEnabled: Boolean
    $dateOfBirth: String
    $phoneNumber: String
  ) {
    updateUserDetails(
      fullName: $fullName
      doneOnBoarding: $doneOnBoarding
      pushNotificationsEnabled: $pushNotificationsEnabled
      dateOfBirth: $dateOfBirth
      phoneNumber: $phoneNumber
    ) {
      ok
    }
  }
`;
